import $ from 'jquery';
import { keys, omitBy, pickBy } from 'lodash';
import { parse } from 'query-string';

import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as ajax from './ajax';
import * as annotation from './annotation';
import * as artifactHealth from './artifactHealth';
import * as auth from './auth';
import * as aws from './aws';
import * as badge from './badge';
import * as build from './build';
import * as buildHealth from './buildHealth';
import * as chart from './chart';
import * as colours from './colours';
import * as commonPageInfo from './commonPageInfo';
import * as componentHelper from './componentHelper';
import * as date from './date';
import * as dispatcherTypes from './dispatcherTypes';
import * as httpRequestHeader from './httpRequestHeader';
import * as installer from './installer';
import * as job from './job';
import * as jobNames from './jobNames';
import * as messaging from './messaging';
import * as metrics from './metrics';
import * as metricsPagesHelper from './metricsPagesHelper';
import * as modals from './modals';
import * as nodeIssues from './nodeIssues';
import * as notifications from './notifications';
import * as pageTypes from './pageTypes';
import * as params from './params';
import * as reducerHelpers from './reducers';
import * as regressionPages from './regressionPages';
import * as scan from './scans';
import * as scenarios from './scenarios';
import * as selectors from './selectors';
import * as signalR from './signalR';
import * as sonar from './sonar';
import * as storage from './storage';
import * as telemetry from './telemetry';
import * as toasts from './toasts';
import * as unicode from './unicode';
import * as urls from './urls';
import * as utils from './utils';
export {
  actions,
  actionTypes,
  ajax,
  annotation,
  artifactHealth,
  auth,
  aws,
  badge,
  build,
  buildHealth,
  chart,
  colours,
  commonPageInfo,
  componentHelper,
  date,
  dispatcherTypes,
  httpRequestHeader,
  installer,
  job,
  jobNames,
  messaging,
  metrics,
  metricsPagesHelper,
  modals,
  nodeIssues,
  notifications,
  pageTypes,
  params,
  reducerHelpers,
  regressionPages,
  scan,
  scenarios,
  selectors,
  signalR,
  sonar,
  storage,
  unicode,
  telemetry,
  toasts,
  urls,
  utils
};

export const HOST = `${window.location.protocol}//${window.location.host}/#`;

export const SUPER_SELECT_ALL_PREFIX = '* Select All';

export const CASE_METRICS_TOGGLES = {
  ...build.BIT_TYPE,
  OUTLIER: 8,
  ARTIFACT_ONLY: 16
};

export const PERFORMANCE_METRICS_TOGGLES = {
  ...build.BIT_TYPE,
  OUTLIER: 8
};

export const CASE_AMENDING_TOGGLES = {
  ...build.BIT_TYPE,
  OUTLIER: 8
};

export const CASE_AMENDING_KPP_TOGGLES = {
  ...build.BIT_TYPE,
  OUTLIER: 8
};

export const EXPORT_METRICS_TOGGLES = {
  ...build.BIT_TYPE,
  OUTLIER: 8
};

export const PROD_DASHBOARD_BASE_URL = 'http://build-dashboard.ourmagnet.net/#';

export const copyToClipboard = (text) => {
  const clipboard = $.find('[data-clipboard=\'true\']')[0];

  if (!clipboard) {
    return false;
  }

  clipboard.value = text;
  clipboard.select();

  return document.execCommand('copy');
};

export const DispatcherTypes = {
  Artifact: 'ArtifactRegression',
  White: 'UITests',
  Export: 'ExportTests'
};

export const getHash = (str) => {
  // Port of djb2 hash from http://www.cse.yorku.ca/~oz/hash.html
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    hash = ((hash << 5) + hash) + c;
  }

  return hash;
};


export const openProtocolUrl = (protocol, path) => {
  // Finds the element introduced by the CustomProtocolOpenerComponent.
  const opener = $.find('[data-protocol-opener=\'true\']')[0];

  if (!opener) {
    return false;
  }

  opener.contentWindow.location.href = `${protocol}:${path}`;

  return true;
};

export const mergeParamsWithUrlQuery = (query, params) => {
  const searchParams = parse(query);
  const paramKeys = keys(params);
  const extraParams = pickBy(searchParams, (value, key) =>
    !paramKeys.some(k => k === key)
  );
  return {
    ...omitBy(params, p => !p || p.length === 0),
    ...extraParams
  };
};

/**
 * Creates a lookup object for all Param string constants defined in helpers/params.js
 * The constants are used as a whitelist when STS prunes the db of unnecessary params.
 * It can also be used here to trim incoming params from the back end
 * * Key is paramName as seen in DB, Value is constant name as defined in helpers/params
 */
export const getDefinedParamStringConstants = function() {
  const definedConstants = Object.keys(params).reduce((acc, propName) => {
    const val = params[propName];
    if (typeof val === 'string') {
      acc[val] = propName;
    }
    return acc;
  }, {});
  return definedConstants;
}();


// WEBPACK FOOTER //
// src/helpers/index.js